export const CANDIDATE_DETAILS_FR = {
  chat: {
    header: 'Laissez-nous vos commentaires',
    toggleButton: 'Écrivez à {{ managerName }}',
    toggleButton_open: '$t(candidateDetails.chat.header)',
    toggleCloseHint: 'Fermer',
    fullScreenButton: 'Plein écran',
    sendButtonAriaLabel: 'Envoyer',
    message: {
      heading:
        '{{ authorFullName }} - $t(common.formatting.date.dateFormat) heures $t(common.formatting.date.dateFormat_time)',
      defaultMessageFeedback:
        'Bonjour {{ name }}, si vous avez quelque chose à nous signaler, veuillez utiliser ce chat.',
      defaultMessageFeedback_positive:
        "Bonjour {{ name }}, pourquoi <strong>êtes-vous intéressé</strong>? Voulez-vous approfondir certains aspects lors de l'entretien ?",
      defaultMessageFeedback_negative:
        'Bonjour {{ name }}, écrivez-moi vos motivations afin que nous puissions affiner la recherche de candidats.',
    },
  },
  dossier: {
    title: 'Summary & CV',
    subtitle: "Entretien d'embauche",
    button: 'Télécharger le dossier',
    showCurriculumButton: 'Afficher le CV',
    modalTitle:
      '{{ candidateFullName }} | $t(candidate.sections.curriculum.title)',
    modalCloseButtonAriaLabel: 'Fermer',
  },
  feedback: {
    bubble:
      "Aimerais-tu mieux connaître {{ candidateFullName }} lors d'un <strong>entretien</strong>?",
    bubble_interested:
      '<strong>{{ candidateFullName }}</strong> vous intéresse',
    bubble_notInterested:
      '<strong>{{ candidateFullName }}</strong> ne vous intéresse pas',
    bubble_discarded:
      '<strong>{{ candidateFullName }}</strong> ne continue pas.',
    actionYes: 'Oui',
    actionNo: 'Non',
    actionChangeFeedback: "As-tu changé d'avis?",
    interesting: "C'est intéressant",
  },
  info: {
    age: '{{ age }} années',
    drivingTime: {
      hours: '<strong>{{ hours }}</strong>h',
      minutes: '<strong>{{ minutes }}</strong>min',
    },
  },
  intro: {
    editLink: 'Modifier la candidature',
  },
  negativeFeedback: {
    title: "Pourquoi n'est-il/elle pas intéressant(e)?",
    subtitle:
      'Savoir pourquoi vous ne trouvez pas ce candidat adapté au poste (par exemple, compétences, ancienneté, etc.) nous aide à ne présenter que des candidats parfaitement en adéquation avec vos attentes.',
    notesLabel: 'Écrivez la motivation:',
    notesPlaceholder:
      'La motivation sera envoyée au/ à la chargé.e de recrutement qui gère la sélection.',
    submit: 'Envoyer',
    cancel: 'Annuler',
    successTitle: 'Message envoyé:',
    successSubtitle:
      'Nous avons transmis votre évaluation au/ à la chargé.e de recrutement qui gère la recherche.',
    successClose: "D'accord, merci.",
  },
  scout: {
    accordionOpen: "Plus d'infos",
    accordionClose: 'Fermer',
    title: 'Rapport talent scout',
    accordionTitle_skillsAssessment: 'Évaluation des compétences',
    accordionTitle_overallAssessment: 'Résumé du rôle',
    button: 'Télécharger le rapport',
  },
};
